import { findTargets, findTarget, formFieldsInside } from '../utils/Utils';

const formPart = (() => {
  const config = {
    triggers: [...document.querySelectorAll('.js-formPartTrigger')],
    targetCN: 'js-formPartTarget',
    parentCN: 'js-formPartParent',
    hideCN: '-hide',
    excludeCN: 'js-filterSectionTarget.-hide',
  };

  const handleTarget = (element) => {
    // show target
    element.classList.remove(config.hideCN);
    // accessibility
    element.setAttribute('aria-hidden', 'false');
    // enable all inputs inside
    // BUT! here it gets a little trickier…
    // some of the form selects hide and show some part of the form…
    // we should not enable the form fields that are hidden
    const dontEnableThese = [...element.querySelectorAll(`.${config.excludeCN} select`), ...element.querySelectorAll(`.${config.excludeCN} input`), ...element.querySelectorAll(`.${config.excludeCN} textarea`)];
    formFieldsInside.enable(element, dontEnableThese);


    const aAction = findTarget({
      element: element,
      parent: 'js-formPartParent',
      target: 'js-formApartment',
    });
    let sAction = element.dataset.action;
    console.log(sAction)
    if(aAction && sAction) {
      aAction.action = sAction
    }

//    trigger.form.action = trigger.options[trigger.selectedIndex].value;

    console.log();

  };

  const handleSiblings = (arr) => {
    // hide all sibling sections
    arr.forEach((sibling) => {
      // add correct classname to hide
      sibling.classList.add(config.hideCN);
      // accessibility
      sibling.setAttribute('aria-hidden', 'true');
      // disable all inputs inside
      formFieldsInside.disable(sibling);
    });
  };

  const handleClick = (trigger) => {
    // get all the targets in container
    const targets = [...findTargets({
      element: trigger,
      parent: config.parentCN,
      target: config.targetCN,
    })];
    // find the real click target
    const target = targets.filter(element =>
      parseFloat(element.dataset.index) === parseFloat(trigger.value))[0];
    // get all the siblings of the target
    const siblings = targets.filter(element =>
      parseFloat(element.dataset.index) !== parseFloat(trigger.value));

    handleSiblings(siblings);
    handleTarget(target);
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => handleClick(trigger));
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default formPart.init();
